import { useEffect, useState, ChangeEvent, Dispatch, SetStateAction } from 'react'
import { TextField, FormControl, InputLabel, Select, SelectChangeEvent, MenuItem, OutlinedInput, Checkbox, Autocomplete, IconButton, Box } from '@mui/material'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Groups } from '../types';
import debounce from '../helpers/debounce';
import { FilterOption } from '../views/corp/waterline-management/types';

type CorpCalendarFiltersProps = {
  groups: Groups[];
  filterByType: string;
  filterByGroup: Groups[];
  setFilterByType: Dispatch<SetStateAction<string>>;
  setFilterByGroup: Dispatch<SetStateAction<Groups[]>>;
  setSearch: Dispatch<SetStateAction<string>>;
  filterOptions: FilterOption[];
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CorpCalendarFilters = (props: CorpCalendarFiltersProps) => {
  const {
    groups,
    setSearch,
    setFilterByType,
    setFilterByGroup,
    filterOptions,
  } = props

  const [searchTerm, setSearchTerm] = useState('')
  const [typeFilter, setTypeFilter] = useState('')
  const [groupFilter, setGroupFilter] = useState<Groups[]>([])

  const handleSearch = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const searchValue = event.target.value
    setSearchTerm(searchValue)
  }

  const handleFilterByType = (event: SelectChangeEvent<string>) => {
    const filterOption = event.target.value
    setTypeFilter(filterOption)
  }

  useEffect(() => {
    setSearch(searchTerm)
    setFilterByType(typeFilter)
    setFilterByGroup(groupFilter)
  }, [searchTerm, typeFilter, groupFilter])

  const debouncedHandleSearch = debounce(handleSearch, 50)

  return (
    <>
      <Box className="flex flex-space-between" sx={{ width: '100%' }}>
        <div className="flex">
          <FormControl sx={{ mr: 2, minWidth: 200 }} size="small">
            <InputLabel id="filter-by-type-select-label">Filter By Result</InputLabel>
            <Select
              labelId="filter-by-type-select-label"
              id="filter-by-type-select"
              value={typeFilter}
              input={<OutlinedInput label="Filter By Result" />}
              onChange={handleFilterByType}
            >
              {
                filterOptions.map((option: FilterOption) => (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
          {
            groups.length ? (
              <Autocomplete
                multiple
                onChange={(_event, newValue) => {
                  setGroupFilter(newValue);
                }}
                options={groups}
                disableCloseOnSelect
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                    {option.name}
                  </li>
                )}
                size="small"
                style={{ minWidth: 200, maxWidth: 500, marginRight: '16px' }}
                renderInput={(params) => <TextField {...params} label="Filter by Group" />}
              />
            ) : null
          }
        </div>
        <TextField sx={{ minWidth: 200 }} size="small" label="Search" onChange={debouncedHandleSearch} InputProps={{
          endAdornment: (
            <IconButton>
              <FontAwesomeIcon icon="magnifying-glass" size="sm" className="m-l-8" />
            </IconButton>
          )
        }} />
      </Box>
    </>
  )
}

export default CorpCalendarFilters
